import type { FC } from 'react';

import { AlertCircle as Component } from '@untitledui-pro/icons/solid/AlertCircle';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type AlertCircleProps = IconProps;

export const AlertCircle: FC<AlertCircleProps> = (props) => <BaseIcon {...props} Component={Component} />;
